<template>
  <div class="home">
    <h1>Welcome to Home Page</h1>
    <p>This is your home page content.</p>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>
